import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import fetchApi from '../utils/api.js';
import Swal from 'sweetalert2';

const InvoiceCopyForm = ({ isOpen, onClose, copy, isPage }) => {
    const [name, setName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);

    const user = JSON.parse(sessionStorage.getItem('user'));
    const isSuperAdmin = user?.role === 'SUPER_ADMIN';

    useEffect(() => {
        if (copy) {
            setName(copy.invoiceCopyName || copy.invoice_copy_name || '');
            const cid = copy.companyId?._id || copy.companyId || copy.company_id;
            setCompanyId(cid ? cid : 'all');
        } else {
            setName('');
            setCompanyId('');
        }
    }, [copy]);

    useEffect(() => {
        if (isSuperAdmin && isOpen) {
            fetchCompanies();
        }
    }, [isSuperAdmin, isOpen]);

    const fetchCompanies = async () => {
        try {
            const data = await fetchApi('/company');
            setCompanies(data.companies || data);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const conf = await Swal.fire({
            title: 'Save Data?',
            text: 'Are you sure you want to save this data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00334e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'No, Keep Editing'
        });
        if (!conf.isConfirmed) return;
        const trimmedName = name.trim();
        if (!trimmedName) {
            toast.error("Copy Name is required");
            return;
        }

        if (isSuperAdmin && !companyId) {
            toast.error("Company selection is required");
            return;
        }

        setLoading(true);
        try {
            const id = copy?._id || copy?.id;
            const url = copy ? `/invoice-copy/${id}` : '/invoice-copy';
            const method = copy ? 'PUT' : 'POST';

            const payload = {
                invoiceCopyName: trimmedName,
                ...(isSuperAdmin && { companyId })
            };

            await fetchApi(url, {
                method: method,
                body: JSON.stringify(payload)
            });

            toast.success(copy ? "Updated Successfully" : "Added Successfully");
            onClose();
        } catch (error) {
            console.error("Error saving invoice copy:", error);
            toast.error(error.message || "Server error");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={isPage ? "list-page-container" : "modal-overlay"}>
            <div className={isPage ? "" : "modal"}>
                <div className="modal-header">
                    <h2 className="modal-title">{copy ? 'Update Invoice Copy' : 'Add Invoice Copy'}</h2>
                    {!isPage && <button className="modal-close" onClick={onClose}>&times;</button>}
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-grid">
                            {isSuperAdmin && (
                                <div className="form-field">
                                    <label>SELECT COMPANY</label>
                                    <select
                                        value={companyId}
                                        onChange={(e) => setCompanyId(e.target.value)}
                                        required
                                        className="form-control"
                                        style={{ width: '100%', height: '35px', borderRadius: '4px', border: '1px solid #ccc' }}
                                    >
                                        <option value="">Select Company</option>
                                        <option value="all">All</option>
                                        {companies.map(comp => (
                                            <option key={comp._id || comp.id} value={comp._id || comp.id}>
                                                {comp.companyName || comp.name || comp.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="form-field">
                                <label>INVOICE COPY NAME</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter copy name"
                                    required
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="modal-footer" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                            <button type="submit" className="btn-submit" disabled={loading}>
                                {loading ? "Saving..." : "Submit"}
                            </button>
                            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default InvoiceCopyForm;
